{
  "it": {
    "baseBtn": {
      "labels": {
        "loading": "Attendere..."
      },
      "confirm": {
        "question": "Sicuro?",
        "yes": "Sì",
        "no": "No"
      }
    }
  }
}
